/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import './StreamingCursorStyles.scss';
const baseClass = 'qmb-ui-streaming-cursor';
/**
 * StreamingCursor Component
 * A blinking cursor animation appended to streaming markdown text.
 * @version 1.0.0
 * @since 2026-02-18
 */
export function StreamingCursor({ className }) {
    return React.createElement("span", { className: classNames(baseClass, className), "aria-hidden": "true" });
}
